module.exports = __webpack_public_path__ + "img/05.6d8314b2.png";